module.exports = __webpack_public_path__ + "ipetbooking-landing/img/section5-image@2x.1929f998.png";